<template>
  <div>
    <span class="yes-no">{{ verboseValue }}</span>
  </div>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    verboseValue() {
      if (this.value === true) {
        return 'Yes'
      } else {
        return 'No'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.yes-no {
  font-size: 14px;
  background-color: #f5f7fa;
  color: #303133 !important;
  font-weight: bold;
  cursor: not-allowed;
  padding: 0.2rem 0.5rem;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>
